import React, { useReducer, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AddCreate from "../../components/AddCreate/AddCreate";
import UseWritePost from "../../hooks/UseWritePost";
import { AddInsertreducer } from "../../interface/ActionReducer";
import { AddState } from "../../interface/initialState";
import { AddInter } from "../../interface/interface";

type LocType = {
  state: AddInter | undefined;
};

function LineAdd() {
  const location = useLocation() as LocType;
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(AddInsertreducer, AddState);
  const [WritePost] = UseWritePost("띠배너가 등록되었습니다");
  const UpadteInfo = useCallback(
    (type: string, payload: string | number) => {
      dispatch({
        type,
        payload,
        index: undefined,
      });
    },
    [dispatch]
  );
  const NewLine = useCallback(() => {
    const {
      ctts_tit,
      btn_label,
      ctts_ctts,
      bg_color,
      ctts_link,
      ad_thumbnail,
      ctts_ctg_cd,
      ctts_id,
    } = state;
    if (
      ctts_tit &&
      btn_label &&
      ctts_ctts &&
      bg_color &&
      ctts_link &&
      ad_thumbnail
    ) {
      WritePost(
        {
          bbs_id: "5",
          ctts_tit,
          ad_thumbnail,
          btn_label,
          ctts_ctg_cd,
          ctts_ctts,
          bg_color,
          ctts_link,
          ctts_id,
        },
        false
      ).then(() => {
        navigate(-1);
      });
    }
  }, [WritePost, state, navigate]);
  useEffect(() => {
    dispatch({
      type: "add/type",
      payload: "line",
      index: undefined,
    });

    if (location.state) {
      const {
        ctts_ctg_cd,
        ctts_ctts,
        ctts_link,
        ctts_tit,
        ad_thumbnail,
        bg_color,
        btn_label,
        ctts_id,
      } = location.state;

      dispatch({
        type: "add/all",
        payload: {
          bg_color: bg_color,
          ctts_id,
          ctts_ctts,
          ad_thumbnail: ad_thumbnail,
          ctts_link,
          ctts_tit,
          btn_label: btn_label,
          ctts_ctg_cd,
        },
        index: undefined,
      });
    }
    return () => {};
  }, [location]);

  return (
    <AddCreate
      data={state}
      UpdateInfo={UpadteInfo}
      WritePost={NewLine}
      addType="line"
    />
  );
}

export default LineAdd;
